import "normalize.css";
import "./src/styles/global.css";
import "./src/pages/index.module.css";

export const onClientEntry = () => {
	let currentDpr;
	let removeDprListener = () => {};

	const updateFontSize = () => {
		const dpr = window.devicePixelRatio || 1;
		if (dpr === currentDpr) return;
		currentDpr = dpr;
		document.documentElement.style.setProperty(
			"--font-size-reduction",
			dpr > 2 ? "2px" : "0px"
		);

		removeDprListener();
		const query = window.matchMedia(`(resolution: ${dpr}dppx)`);
		if (typeof query.addEventListener === "function") {
			query.addEventListener("change", updateFontSize);
			removeDprListener = () => query.removeEventListener("change", updateFontSize);
		} else {
			query.addListener(updateFontSize);
			removeDprListener = () => query.removeListener(updateFontSize);
		}
	};

	updateFontSize();
	window.addEventListener("resize", updateFontSize);
	window.visualViewport?.addEventListener("resize", updateFontSize);
};
